// マイページ利用規約
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowserBack } from '../../BrowserBack';
import TransitionButton from '../../molecules/TransitionButton';
import Annotation from '../../atoms/Annotation';
import Heading from '../../molecules/Heading';
import Block from '../../molecules/Block';
import CenterButton from '../../atoms/CenterButton';
import Popup from '../../molecules/Popup';
import LoadingModal from '../../molecules/LoadingModal';

const MypageTermsService: React.FC = () => {
  // 同意文の取得
  const [agreement_text, setAgreementText] = useState({
    id: '',
    text: '',
    clause_text: '',
    last_update: '',
  });
  // 同意するボタンの制御
  const [is_disabled, setIsDisabled] = useState(true);
  // ポップアップの表示制御
  const [modal_show, setModalShow] = useState(false);
  // ポップアップのボタン情報
  const [popup_button, setPopupButton] = useState({
    label: '閉じる',
    variant: 'success',
    handleClick: () => popupButtonClick(),
  });
  // ローディング画面表示制御
  const [is_loading, setIsLoading] = useState(true);
  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const update = url_params.get('update');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 規約文の取得
    fetchLists();
  }, []);

  // 同意文の取得と現在有効なマイページ利用規約に同意していない場合にボタン名の書き換え
  const fetchLists = async () => {
    try {
      const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/api/get_terms_service`, {
        params: {
          update_flg: update ?? '',
        },
      });
      setAgreementText(response.data);
      update &&
        setPopupButton(prevState => {
          return { ...prevState, ['label']: '同意する' };
        });
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  };

  // ポップアップ内のボタン押下時
  const popupButtonClick = () => {
    setModalShow(false);
    setIsDisabled(false);
  };

  // 同意するボタン
  const handleClick = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/agreement_terms_service`, {
        clauses_id: agreement_text['id'],
      });

      // 画面遷移
      location.replace(response.data);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      alert('システムエラーが発生しました');
    }
  };

  // マイページへ戻るボタン押下
  const transitionMypage = () => {
    setIsLoading(true);
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`);
  };

  // ログアウトボタン押下時
  const Logout = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/logout`);
    } catch (error) {
      console.error(error.message);
    } finally {
      //ログアウト処理の成否に関わらずマイページログイン画面に遷移する。
      location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/login`);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Heading label="マイページ利用規約" size="l" />
      <Block
        label="利用規約"
        content={
          <>
            <div className="content-box">
              <Heading label="マイページ利用規約確認" size="s" />
              {update ? (
                <Annotation text="利用規約が更新されています。「利用規約を表示する」を押して、利用規約を表示し、内容をご確認下さい。" />
              ) : (
                <Annotation text="「利用規約を表示する」を押して、利用規約を表示し、内容をご確認下さい。" />
              )}
              <CenterButton
                label="利用規約を表示する"
                btn_class="btn-base"
                is_disabled={false}
                handleClick={() => setModalShow(true)}
              />
            </div>
            {update ? (
              <div className="content-box">
                <Annotation text="※利用規約をご確認いただき、同意する場合は、「同意する」ボタンを押して下さい。" />
                <CenterButton
                  btn_class="arrow-right"
                  label="同意する"
                  is_disabled={is_disabled}
                  handleClick={handleClick}
                />
                <TransitionButton label="ログアウトする" btn_class="line" handleClick={Logout} />
              </div>
            ) : (
              <TransitionButton
                label="マイページへ戻る"
                btn_class="two_lines"
                handleClick={transitionMypage}
              />
            )}
          </>
        }
      />
      <Popup
        title="マイページ利用規約"
        sub_title="利用規約"
        last_update={agreement_text.last_update}
        text={agreement_text.text ?? agreement_text.clause_text}
        toggleShow={modal_show}
        toggleClose={() => setModalShow(false)}
        first_button={popup_button}
      />
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('mypage-terms-service')) {
  render(<MypageTermsService />, document.getElementById('mypage-terms-service'));
}
